// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-textarea {
    flex: 1 1;
    padding: 10px;
    box-sizing: border-box;
    border: 2px solid #E3E9F4;
    border-radius: 12px;
    width: auto !important;
}

.day-box{
    margin-top: 8px;
    background: var(--Surface-selected-dropdown, rgba(227, 233, 244, 1));
    height: 40px;
    width: 40px;
    border-radius: 12px;
    font-size: 12px;
    padding: 10px;
    font-weight: 500;
    cursor: pointer;
}

.input-error {
  border: 2px solid var(--red-300) !important;
  box-shadow: 0 0 5px 2px var(--red-200);
  flex: 1 1;
    padding: 10px !important;
    box-sizing: border-box;
    border-radius: 12px;
}

.select-error {
  flex: 1 1;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 12px;
  border: 2px solid var(--red-300) !important;
  box-shadow: 0 0 5px 2px var(--red-200);
  margin-bottom: 15px;
}

.error-msg {
  font-size: 13px;
    color: #FF6969;
    margin-bottom: 15px;
    margin-top: -10px;
}

.selected-day-box{
    margin-top: 8px;
    background: var(--Main-Primary-teal-500, rgba(48, 213, 200, 1));
    height: 40px;
    width: 40px;
    border-radius: 12px;
    font-size: 12px;
    padding: 10px;
    font-weight: 500;
    cursor: pointer;
}

.weekday-container{
    width: 10vw;
}

.weektime-shift{
    width: 9vw;
}

.options-container{
    width: 15vw;
    border-right: 2px solid var(--Badges-badge-border-grey, rgba(227, 233, 244, 1));
    height: 83vh;
}

.issue-status .rdt_TableBody{
    height: 27vh !important;
}

.relation-container{
    height: 44px;
    border: 2px solid var(--Surface-input-border, #E3E9F4);
    border-radius: 14px;
    font-weight: 500;
    padding: 10px;
    margin-bottom: 10px;
    width: 52vw;
}

.settings-tab.clicked {
  width: 13vw;
}

.settings-tab{
  border-radius: 14px;
  color: var(--secondary-500);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  font-family: Inter;
  text-align: left;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  background-color: var(--secondary-50);
  position: relative;

}

.settings-tab-unactive {
  color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.6));
  align-self: flex-start;
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  text-align: left;
  font-weight: 600;
  line-height: 130%;
}

.table-container{
    overflow: scroll;
    height: 84vh;
    padding-right: 20px;
}

.popup-container {
    position: fixed;
    top: 75%;
    left: 40.9%;
    transform: translate(-50%, -50%);
    background-color: white;
    box-shadow: 0px 16px 32px 0px rgba(35, 23, 5, 0.26);
    border-radius: 12px;
    z-index: 1000;
    overflow: hidden;
  }
  
  .icon-picker-popup {
    padding: 20px;
  }
  
  .icon-picker {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
  }
  
  .icon-picker-container{
    justify-content: center;
    height: 30vh;
    width: 16vw;
    margin: 8px;
    overflow-y: scroll;
    overflow-x: hidden;
    flex-wrap: wrap;
    display: flex;
  }

  .icon-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    cursor: pointer;
    border: 1px solid transparent;
    border-radius: 5px;
    transition: border-color 0.3s ease;
  }
  
  .icon-item:hover {
    border-color: var(--Badges-badge-border-grey, rgba(227, 233, 244, 1));
  }
  
  .icon-item.selected {
    border-color: var(--Badges-badge-border-grey, rgba(227, 233, 244, 1));
    background-color: #e9ecef;
  }
  
  .icon-item svg {
    width: 30px;
    height: 30px;
    padding: 7px;
    background: var(--Surface-surface-main-light, rgba(239, 243, 249, 1));
    border-radius: 10px;
    color: var(--Text-medium-emphasis, rgba(9, 8, 38, 0.6));
  }

  .selected-icon{
    width: 30px;
    height: 30px;
    padding: 8px;
    background: var(--Surface-surface-main-light, rgba(239, 243, 249, 1));
    border-radius: 10px;
    color: var(--Text-medium-emphasis, rgba(9, 8, 38, 0.6));
  }

  .color-picker{
    border: 2px solid var(--Surface-surface-border, #E3E9F4);
    height: 35px;
    width: 35px;
    border-radius: 10px;
  }

  .color-picker-none{
    border: 2px solid var(--Surface-surface-border, #E3E9F4);
    height: 35px;
    width: 35px;
    border-radius: 10px;
    pointer-events: none;
  }

  .color-container{
    position: fixed;
    top: 73%;
    left: 37.5%;
    transform: translate(-50%, -50%);
    background-color: white;
    box-shadow: 0px 16px 32px 0px rgba(35, 23, 5, 0.26);
    border-radius: 12px;
    z-index: 1000;
    overflow: hidden;
  }

  .color-picker-container{
    height: 16vh;
    width: 10vw;
    margin: 8px;
    overflow-y: scroll;
    overflow-x: hidden;
    align-items: center;
    /* flex-wrap: wrap; */
    display: flex;
  }

  .selected-color{
    height: 32px;
    width: 32px;
    border: 2px solid var(--Surface-surface-border, #E3E9F4);
    border-radius: 10px;
  }

  .choose-icon{
    width: 4.9rem;
    border-top: 2px solid #E3E9F4;
    border-bottom: 2px solid #E3E9F4;
    border-bottom-width: 1px;
     border-top-width: 1px;
  }
  
  /* Optional: Add a backdrop */
  .backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }

  .searching{
    border: 2px solid var(--Surface-surface-border, rgba(227, 233, 244, 1));
    height: 38px;
    margin: 10px;
    padding: 7px !important;
    font-size: 12px;
    width: auto !important;
    margin-bottom: 0px !important;
  }

  .selected-color {
    display: inline-block;
    border: 1px solid #ddd;
  }
`, "",{"version":3,"sources":["webpack://./src/kz-organization/css/settings.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,oEAAoE;IACpE,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;;AAEA;EACE,2CAA2C;EAC3C,sCAAsC;EACtC,SAAS;IACP,wBAAwB;IACxB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;EACE,SAAS;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB,2CAA2C;EAC3C,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,eAAe;IACb,cAAc;IACd,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,+DAA+D;IAC/D,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,+EAA+E;IAC/E,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,sDAAsD;IACtD,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;;AAEpB;;AAEA;EACE,uDAAuD;EACvD,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,WAAW;IACX,gCAAgC;IAChC,uBAAuB;IACvB,mDAAmD;IACnD,mBAAmB;IACnB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,kCAAkC;EACpC;;EAEA;IACE,qEAAqE;EACvE;;EAEA;IACE,qEAAqE;IACrE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,qEAAqE;IACrE,mBAAmB;IACnB,uDAAuD;EACzD;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,qEAAqE;IACrE,mBAAmB;IACnB,uDAAuD;EACzD;;EAEA;IACE,wDAAwD;IACxD,YAAY;IACZ,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,wDAAwD;IACxD,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,WAAW;IACX,gCAAgC;IAChC,uBAAuB;IACvB,mDAAmD;IACnD,mBAAmB;IACnB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,wDAAwD;IACxD,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,gCAAgC;IAChC,wBAAwB;KACvB,qBAAqB;EACxB;;EAEA,6BAA6B;EAC7B;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,YAAY;EACd;;EAEA;IACE,uEAAuE;IACvE,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;EACxB","sourcesContent":[".custom-textarea {\n    flex: 1 1;\n    padding: 10px;\n    box-sizing: border-box;\n    border: 2px solid #E3E9F4;\n    border-radius: 12px;\n    width: auto !important;\n}\n\n.day-box{\n    margin-top: 8px;\n    background: var(--Surface-selected-dropdown, rgba(227, 233, 244, 1));\n    height: 40px;\n    width: 40px;\n    border-radius: 12px;\n    font-size: 12px;\n    padding: 10px;\n    font-weight: 500;\n    cursor: pointer;\n}\n\n.input-error {\n  border: 2px solid var(--red-300) !important;\n  box-shadow: 0 0 5px 2px var(--red-200);\n  flex: 1 1;\n    padding: 10px !important;\n    box-sizing: border-box;\n    border-radius: 12px;\n}\n\n.select-error {\n  flex: 1 1;\n    padding: 10px;\n    box-sizing: border-box;\n    border-radius: 12px;\n  border: 2px solid var(--red-300) !important;\n  box-shadow: 0 0 5px 2px var(--red-200);\n  margin-bottom: 15px;\n}\n\n.error-msg {\n  font-size: 13px;\n    color: #FF6969;\n    margin-bottom: 15px;\n    margin-top: -10px;\n}\n\n.selected-day-box{\n    margin-top: 8px;\n    background: var(--Main-Primary-teal-500, rgba(48, 213, 200, 1));\n    height: 40px;\n    width: 40px;\n    border-radius: 12px;\n    font-size: 12px;\n    padding: 10px;\n    font-weight: 500;\n    cursor: pointer;\n}\n\n.weekday-container{\n    width: 10vw;\n}\n\n.weektime-shift{\n    width: 9vw;\n}\n\n.options-container{\n    width: 15vw;\n    border-right: 2px solid var(--Badges-badge-border-grey, rgba(227, 233, 244, 1));\n    height: 83vh;\n}\n\n.issue-status .rdt_TableBody{\n    height: 27vh !important;\n}\n\n.relation-container{\n    height: 44px;\n    border: 2px solid var(--Surface-input-border, #E3E9F4);\n    border-radius: 14px;\n    font-weight: 500;\n    padding: 10px;\n    margin-bottom: 10px;\n    width: 52vw;\n}\n\n.settings-tab.clicked {\n  width: 13vw;\n}\n\n.settings-tab{\n  border-radius: 14px;\n  color: var(--secondary-500);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 12px;\n  font-family: Inter;\n  text-align: left;\n  font-size: 0.8rem;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 130%;\n  background-color: var(--secondary-50);\n  position: relative;\n\n}\n\n.settings-tab-unactive {\n  color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.6));\n  align-self: flex-start;\n  font-family: Inter;\n  font-size: 0.8rem;\n  font-style: normal;\n  text-align: left;\n  font-weight: 600;\n  line-height: 130%;\n}\n\n.table-container{\n    overflow: scroll;\n    height: 84vh;\n    padding-right: 20px;\n}\n\n.popup-container {\n    position: fixed;\n    top: 75%;\n    left: 40.9%;\n    transform: translate(-50%, -50%);\n    background-color: white;\n    box-shadow: 0px 16px 32px 0px rgba(35, 23, 5, 0.26);\n    border-radius: 12px;\n    z-index: 1000;\n    overflow: hidden;\n  }\n  \n  .icon-picker-popup {\n    padding: 20px;\n  }\n  \n  .icon-picker {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: column;\n  }\n  \n  .icon-picker-container{\n    justify-content: center;\n    height: 30vh;\n    width: 16vw;\n    margin: 8px;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    flex-wrap: wrap;\n    display: flex;\n  }\n\n  .icon-item {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    cursor: pointer;\n    border: 1px solid transparent;\n    border-radius: 5px;\n    transition: border-color 0.3s ease;\n  }\n  \n  .icon-item:hover {\n    border-color: var(--Badges-badge-border-grey, rgba(227, 233, 244, 1));\n  }\n  \n  .icon-item.selected {\n    border-color: var(--Badges-badge-border-grey, rgba(227, 233, 244, 1));\n    background-color: #e9ecef;\n  }\n  \n  .icon-item svg {\n    width: 30px;\n    height: 30px;\n    padding: 7px;\n    background: var(--Surface-surface-main-light, rgba(239, 243, 249, 1));\n    border-radius: 10px;\n    color: var(--Text-medium-emphasis, rgba(9, 8, 38, 0.6));\n  }\n\n  .selected-icon{\n    width: 30px;\n    height: 30px;\n    padding: 8px;\n    background: var(--Surface-surface-main-light, rgba(239, 243, 249, 1));\n    border-radius: 10px;\n    color: var(--Text-medium-emphasis, rgba(9, 8, 38, 0.6));\n  }\n\n  .color-picker{\n    border: 2px solid var(--Surface-surface-border, #E3E9F4);\n    height: 35px;\n    width: 35px;\n    border-radius: 10px;\n  }\n\n  .color-picker-none{\n    border: 2px solid var(--Surface-surface-border, #E3E9F4);\n    height: 35px;\n    width: 35px;\n    border-radius: 10px;\n    pointer-events: none;\n  }\n\n  .color-container{\n    position: fixed;\n    top: 73%;\n    left: 37.5%;\n    transform: translate(-50%, -50%);\n    background-color: white;\n    box-shadow: 0px 16px 32px 0px rgba(35, 23, 5, 0.26);\n    border-radius: 12px;\n    z-index: 1000;\n    overflow: hidden;\n  }\n\n  .color-picker-container{\n    height: 16vh;\n    width: 10vw;\n    margin: 8px;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    align-items: center;\n    /* flex-wrap: wrap; */\n    display: flex;\n  }\n\n  .selected-color{\n    height: 32px;\n    width: 32px;\n    border: 2px solid var(--Surface-surface-border, #E3E9F4);\n    border-radius: 10px;\n  }\n\n  .choose-icon{\n    width: 4.9rem;\n    border-top: 2px solid #E3E9F4;\n    border-bottom: 2px solid #E3E9F4;\n    border-bottom-width: 1px;\n     border-top-width: 1px;\n  }\n  \n  /* Optional: Add a backdrop */\n  .backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 999;\n  }\n\n  .searching{\n    border: 2px solid var(--Surface-surface-border, rgba(227, 233, 244, 1));\n    height: 38px;\n    margin: 10px;\n    padding: 7px !important;\n    font-size: 12px;\n    width: auto !important;\n    margin-bottom: 0px !important;\n  }\n\n  .selected-color {\n    display: inline-block;\n    border: 1px solid #ddd;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
